const namespace = 'phoneNumbers'

export const LOOKUP_PHONE_NUMBERS = `${namespace}/LOOKUP_PHONE_NUMBER`
export const LOOKUP_PHONE_NUMBERS_SUCCESS = `${namespace}/LOOKUP_PHONE_NUMBER_SUCCESS`
export const LOOKUP_PHONE_NUMBERS_ERROR = `${namespace}/LOOKUP_PHONE_NUMBER_ERROR`
